import { Typography } from "@mui/material";
import { useTheme } from "../../../../../../../../../../../context/themeContext";
import { useSelector } from "react-redux";

const Description = ({ description }) => {
  const { theme } = useTheme();
  const user = useSelector((state) => state.user.value);

  if (!user) {
    return <></>;
  }
  return (
    <Typography
      variant="body1"
      sx={{
        color: theme.palette.darkgrey.darkgrey400,
        fontSize: "16px",
        fontWeight: "500",
        width: "100%",
        overflow: "hidden",
      }}
    >
      {description}
    </Typography>
  );
};

export default Description;
